// extracted by css-extract-rspack-plugin
export default {"link":"_25f7a804"};